import React, { Component } from "react";
import { observer } from "mobx-react";
import Tab from "../tap";
import Title from "../GoBackShop";
import AnswerList from "./AnswerList";
import AnswerDetail from "./AnswerDetail";
import { findAllQuestionByGroupId } from "../../static/js/http";
import { deXMLFilter } from '../../static/js/utils'
@observer
class Person extends Component {
  constructor() {
    super();
    this.state = {
      isDetail: false,
      detailId: "",
      UnAnsweredList: [],
      groupData: {},
      newLoading: true,
    };
  }
  componentDidMount() {
    this.initData();
  }
  initData = () => {
    findAllQuestionByGroupId()
      .then((res) => {
        try {
          if(res.pageData.length > 0) {
            res.pageData.map(item => {
              item.storeQuestionEntity.answer = deXMLFilter(item.storeQuestionEntity.answer)
              item.storeQuestionEntity.question = deXMLFilter(item.storeQuestionEntity.question)
            })
          }
        } catch(e) {
          console.error('反转义失败',e)
        }
        this.setState({
          UnAnsweredList: res.pageData,
          isDetail: false,
          newLoading: false,
        });
      })
      .catch((err) => {});
  };
  questionDetail(data) {
    this.setState({
      groupData: data.storeGroupEntity,
      detailId: data.storeQuestionEntity.id,
      isDetail: true,
    });
  }

  render() {
    const Loading = () => {
      return (
        <div className="loading">
          <span></span>
          <p>正在加载...</p>
        </div>
      );
    };
    return (
      <div className="Person">
        <Title />
        {this.state.isDetail ? (
          <AnswerDetail
            detailId={this.state.detailId}
            groupData={this.state.groupData}
            initData={this.initData}
          />
        ) : this.state.newLoading ? (
          <Loading />
        ) : (
          <AnswerList
            UnAnsweredList={this.state.UnAnsweredList}
            questionDetail={(val) => this.questionDetail(val)}
          />
        )}
        <Tab />
      </div>
    );
  }
}
export default Person;
